<template>
  <div class="usefooter">
    <div class="footerBg">
      <div class="footerTop">
        <div class="footerLeft">
          <div class="title">
            <img src="../assets/images/logoWhite.png" alt="" @click="gotoPage" />
          </div>
          <!-- <div class="tipName">施乐辉</div> -->
          <div class="text">
            <p>
              施乐辉公司于1856年在英国赫尔市成立，是一家超过160年的英国综合性医疗科技公司。我们的使命是——让生命拥有无限可能，目前业务已遍及全球100多个国家，其骨骼修复、运动损伤修复、伤口护理及耳鼻喉手术产品享誉全球。
            </p>
            <p style="margin-top: 10px">
              施乐辉公司于1994年在上海设代表机构，开展对华业务。目前，施乐辉在上海设大中华区总部，并在苏州建立生产基地，产品销往全球。
            </p>
          </div>
        </div>
        <div class="footerRight">
          <div style="margin-bottom: 20px; letter-spacing: 1px">
            更多施乐辉中国信息，敬请关注施乐辉微信矩阵
          </div>
          <div class="moreQrCode">
            <div class="littleCode" style="width: 100%">
              <div class="imgBg">
                <img src="../assets/images/smithnphew.png" alt="" />
              </div>
              <div class="name">施乐辉官方微信</div>
              <span class="tip">让生命拥有无限可能</span>
            </div>
            <div class="littleCode">
              <div class="imgBg">
                <img src="../assets/images/work.png" alt="" />
              </div>
              <div class="name">施乐辉招聘</div>
              <span class="tip">让职业发展拥有无限可能</span>
            </div>
            <div class="littleCode">
              <div class="imgBg">
                <img src="../assets/images/slhcard.png" alt="" />
              </div>
              <div class="name">施乐辉仙卡</div>
              <span class="tip">开启美丽祛疤之旅</span>
            </div>
            <div class="littleCode">
              <div class="imgBg">
                <img src="../assets/images/ysh.png" alt="" />
              </div>
              <div class="name" style="padding: 1px 13px">e施汇</div>
              <span class="tip">获取全球前沿医学教育资源</span>
            </div>
          </div>
        </div>
      </div>
      <div class="footerBottom">
        <div>
          <span>施乐辉医用产品国际贸易（上海）有限公司<span style="font-weight: 400">&nbsp;.&nbsp;</span>版权所有</span>
          <span @click="ToJumps(1)">&nbsp; Cookie声明&nbsp;</span>
          <span>|</span>
          <span @click="ToJumps(2)">&nbsp;使用条款&nbsp;</span>
          <span>|</span>
          <span @click="ToJumps(3)">&nbsp;联系我们&nbsp;</span>
        </div>

        <div @click="ToJumps(4)" style="margin-top: 8px">
          沪ICP备14050722号（沪）-非经营性-2021-0290
        </div>
        <div class="gongan"><img src="../assets/images/gongan.png" alt=""><a style="color: #fff;"
            href="https://beian.mps.gov.cn/#/query/webSearch?code=31010602008187" rel="noreferrer"
            target="_blank">沪公网安备31010602008187</a></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      IsDialog: false,
    };
  },
  methods: {
    // 跳转首页
    gotoPage() {
      // window.open("https://www.smith-nephew.com");
      this.$emit("childEvent", true);
    },
    //   Cookie使用条款   |   法律条款   |   联系我们
    ToJumps(item) {
      if (item == 1) {
        this.$router.push({ path: "/CookieVue" });
      } else if (item == 2) {
        this.$router.push({ path: "/legalPage" });
      } else if (item == 3) {
        window.open(
          "http://weclientent.smith-nephew.com.cn/AnnualMeeting/Modules/questionnaire/wenjuan.aspx"
        );
      } else {
        window.open(" https://beian.miit.gov.cn/");
      }
    },
  },
  created() { },
};
</script>
<style lang="scss" scoped>
.usefooter {
  // height: 60vh;
  // width: 100%;
  background-color: #00719c;
  color: #fff;
  text-align: center;
  font-weight: 300;
  padding: 40px 0 20px;

  // position: absolute;
  // bottom: 0%;
  .footerBg {
    @media (min-width: 1920px) {
      margin: 0 208px;
    }

    @media (min-width: 1000px) and (max-width: 1920px) {
      margin: 0 108px;
    }

    @media (max-width: 1000px) {
      margin: 0 20px;
    }

    .footerTop {
      @media (min-width: 1000px) {
        display: flex;
        justify-content: space-between;
        height: 370px;
      }
    }

    .footerLeft {
      text-align: start;

      @media (min-width: 1000px) {
        width: 38%;
      }

      .title {
        img {
          display: block;
          width: 192px;
          height: auto;
          cursor: pointer;
        }
      }

      .tipName {
        font-size: 15px;
        font-weight: 500;
        margin-top: 5px;
      }

      .text {
        margin: 40px 0;

        p {
          line-height: 21px;
          font-size: 13px;
          text-align: justify;
          font-family: "SNEmericWeb_Book";
          font-weight: 400;
        }
      }
    }

    .footerRight {
      // @media (min-width: 2033px) {
      //   width: 40%;
      // }

      @media (min-width: 1000px) {
        width: 50%;
      }

      font-size: 13px;

      .moreQrCode {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: flex-start;

        .littleCode {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          margin-top: 10px;
          width: percentage(1/3);

          .imgBg {
            // border-radius: 5px;
            // background-color: #fff;
            // width: 83px;
            // height: 84px;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              @media (min-width: 1000px) {
                width: 80px;
              }

              @media (max-width: 1000px) {
                width: 60px;
              }

              height: auto;
            }
          }

          .name {
            padding: 1px 4px;
            background-color: #fff;
            border-radius: 4px;
            color: #00719c;
            font-weight: 500;
            margin: 8px 0;

            @media (max-width: 1000px) {
              font-size: 10px;
            }
          }

          .tip {
            @media (max-width: 1000px) {
              font-size: 9.3px;
            }
          }
        }
      }
    }

    .footerBottom {
      font-size: 11px;
      cursor: pointer;
      letter-spacing: 1px;
      font-weight: 200;

      @media (max-width: 1000px) {
        font-size: 11px;
        margin-top: 20px;
      }
      .gongan {
        margin-top: 8px;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        img{
          width: 14px;
          margin-right: 2px;
        }
      }
    }
  }
}
</style>